import { LogicalNode } from "app/types/record-management-types";
import { ResolvedRelatedList } from "../types";

export const buildRelatedListQueryParams = (
    relatedList: Pick<ResolvedRelatedList, "relationshipType" | "targetColumnName">,
    routeId: string
): LogicalNode => ({
    type: "logical",
    operator: "and",
    conditions: [{ type: "condition", field: relatedList.targetColumnName,
        operator: relatedList.relationshipType === "inheritance_ancestors" ? "in_ancestor_chain" : "eq", value: routeId }],
});
